import { execute as fetchHeroBanner } from "@faire/web-api/api/discover-page/hero-banner/keyword/get";
import { getQueryKey as getHeroBannerQueryKey } from "@faire/web-api/api/discover-page/hero-banner/keyword/get-hooks";
import { IDiscoverPageHeroBanner } from "@faire/web-api/indigofair/data/IDiscoverPageHeroBanner";
import { logError } from "@faire/web/common/logging";

export function getDiscoverPageHeroBannerQueryArgs(searchTerm: string): {
  queryKey: ReadonlyArray<unknown>;
  queryFn: () => Promise<IDiscoverPageHeroBanner>;
} {
  return {
    queryKey: getHeroBannerQueryKey(searchTerm),
    queryFn: () =>
      fetchHeroBanner(searchTerm).catch((error) => {
        logError(error);
        return {} as IDiscoverPageHeroBanner;
      }),
  };
}
